export interface OKRPermissions {
    isOwner: boolean;
    currentUserId: string;
    currentUserName: string;
    /** Only owner sees financial KPI values (€, CA, coûts). */
    canSeeFinancials: boolean;
    /** Only owner sees the full team performance panel. */
    canSeeTeamDetails: boolean;
    /** Only owner can create/edit/delete objectives, KPIs, action plans. */
    canManageObjectives: boolean;
    /** Only owner sees the Templates and Weekly Review management. */
    canSeeOwnerFeatures: boolean;
    /** Everyone can assign tasks to anyone (coordination). */
    canAssignToOthers: true;
    /** Sub-users default to their own tasks view. */
    defaultToOwnTasks: boolean;
}

export function useOKRPermissions(): OKRPermissions {
    const ownerId = localStorage.getItem('ownerId');
    const isOwner = !ownerId;
    const currentUserId = localStorage.getItem('userId') ?? '';
    const currentUserName = localStorage.getItem('name') ?? '';
    const permissions: string[] = (() => {
        try { return JSON.parse(localStorage.getItem('permissions') ?? '[]'); } catch { return []; }
    })();

    const hasFullPermission = isOwner || permissions.includes('all') || permissions.includes('show:number-dashboard');

    return {
        isOwner,
        currentUserId,
        currentUserName,
        canSeeFinancials: hasFullPermission,
        canSeeTeamDetails: isOwner,
        canManageObjectives: isOwner,  // only owner can edit/delete objectives & KPIs
        canSeeOwnerFeatures: isOwner,  // templates, weekly review lock
        canAssignToOthers: true,
        defaultToOwnTasks: !isOwner,
    };
}

/** Returns true if a KPI value should be masked (€ or revenue metric). */
export function isFinancialKPI(unit: string, metricKey?: string): boolean {
    if (unit === '€') return true;
    const financialKeys = ['revenue', 'ca', 'cost', 'avg_order_cost', 'pipeline_value', 'avg_payment_delay', 'invoices_pending'];
    return financialKeys.some((k) => (metricKey ?? '').includes(k));
}
